import styled from "styled-components";

const Error = styled.div`
    font-size: 12px;
    padding: 10px;
    background-color: rgba(210, 65, 65, 0.1);
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 10px;

    span {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #7c0000;
        border-radius: 50%;
        color: white;
        width: 20px;
        height: 20px;
        font-weight: bold;
        font-size: 12px;
    }
`;

export default Error;